(() => {
  const SUMMARY_SELECTOR = '[data-zalvaro-review-summary]';
  const REVIEWS_SELECTOR = '#judgeme_product_reviews';
  const REVIEWS_SECTION_SELECTOR = '[data-zalvaro-review-title]';
  const EMPTY_STATE_SELECTOR = '[data-zalvaro-empty-review]';

  const normalizeText = (value) => value.trim().replace(/\s+/g, ' ').toLocaleLowerCase();

  const syncWidgetPresentation = () => {
    const reviews = document.querySelector(REVIEWS_SELECTOR);
    const reviewsSection = document.querySelector(REVIEWS_SECTION_SELECTOR);
    if (!reviews || !reviewsSection) return;

    const expectedTitle = normalizeText(reviewsSection.dataset.zalvaroReviewTitle || '');
    if (!expectedTitle) return;

    reviews.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]').forEach((heading) => {
      const isDuplicate = normalizeText(heading.textContent || '') === expectedTitle;
      heading.toggleAttribute('data-zalvaro-duplicate-title', isDuplicate);
    });

    const emptyState = reviewsSection.querySelector(EMPTY_STATE_SELECTOR);
    if (emptyState) {
      emptyState.hidden = Boolean(reviews.querySelector('.jdgm-rev'));
    }
  };

  const reviews = document.querySelector(REVIEWS_SELECTOR);
  if (reviews) {
    syncWidgetPresentation();

    new MutationObserver(syncWidgetPresentation).observe(reviews, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest(SUMMARY_SELECTOR);
    if (!summary) return;

    const reviews = document.querySelector(REVIEWS_SELECTOR);
    if (!reviews) return;

    event.preventDefault();
    reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
